import React,{useEffect,useState} from 'react';
import AmbassadorHeader from '../../components/common/AmbassadorHeader';
import Logo from '../../components/common/Logo';
import sampleCsv from '../../assets/data/example.csv';
import SidebarMenu from '../../components/ambassador/SidebarMenu';
import {useNavigate,useLocation} from 'react-router-dom';
import swal from 'sweetalert';
import BulkOnBoardUpload from '../../components/ambassador/BulkOnBoardUpload';
import { getAmbassadorDetail} from '../../actions/AmbassadorActions';
import InMobileSideMenu from '../../components/ambassador/InMobileSideMenu';

function BulkOnBoard(){
   const navigate = useNavigate();
   const [profileDetail, setProfileDetail] = useState({});
  

      useEffect(async() => {
         sessionStorage.getItem("ambDetail")
      ? navigate("/ambassador/bulk-onboard")
      : navigate("/ambassador/login");
   
         await getAmbassadorDetail()
         .then((res) => {
            setProfileDetail(res.data)
         })
   
      },[]) 
    return(
        <>

        <div className='mainAmb_wrapper'>
      {/* Sidebar */}
      <div className={`sidebar_contain`}>
       
            <Logo alt="Logo"/>
            <div className='sidebar_menu_contains'>
               <SidebarMenu detail={profileDetail}/>
            </div>
         
      </div>

      <div className='mobile_sideMenuWrap d-block d-lg-none'>
         <InMobileSideMenu detail={profileDetail}/>
      </div>
      
      <div className='main_contentAmb'>
      {/* Header */}
      <div className='headerAmb_contain'>
      <AmbassadorHeader detail={profileDetail}/>
      </div>
      <div className='amb_content'>
         <div className='container'>
            <div className='row  mt-3'>
                <div className='col-lg-12'>
                    <h2 className='h5 fw-bold'>Bulk On Board</h2>
                </div>
            </div>
            <div className='row  mt-3'>
               <div className='col-lg-12'>
                  <div className='card mb-5 shadow-sm'>
                     {/* <div className='card-header'>
                        <div className='card-title'>Change Password</div>
                     </div> */}
                     <div className='card-body px-4'>
                     <BulkOnBoardUpload detail={profileDetail}/>

                     <div className='row'>
                        <div className='col-md-12 mx-auto'>
                           <div className='bulkUpload_wrapper'>
                              <div className='title_contain text-center'>
                                    <h2>Download CSV Format</h2>
                                    <p>The format of your csv file is important. Please arrange your csv file to match the headers shown below
                                       and then save the file as a CSV UTF-8 (Comma Delimited) filetype. Note : All Fields are require fields
                                    </p>
                              </div>
                        

                              <a href={sampleCsv} download="sample.csv" className='btn btn-sm btn-primary' >Download Sample</a>
                           </div>
                        </div>
                     </div>
                        
                
                     </div>
                  </div>
               </div>
            </div>
         </div>
      
      </div>
      
      </div>


      </div>


        </>
    );
}

export default BulkOnBoard;